import { render, staticRenderFns } from "./permission_apply.vue?vue&type=template&id=9a1ac080&scoped=true&"
import script from "./permission_apply.vue?vue&type=script&lang=js&"
export * from "./permission_apply.vue?vue&type=script&lang=js&"
import style0 from "./permission_apply.vue?vue&type=style&index=0&id=9a1ac080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1ac080",
  null
  
)

export default component.exports